import React, { memo, useEffect, useState } from 'react';
import Toast from '../../components/Toast/Toast';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import { logging } from '../../actions/log';
import { localSetItem, localGetItem } from '../../utils/utils';
import './Setting.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [isEnabled, setIsEnabled] = useState(true);

  const handleChoose = () => {
    setIsEnabled(!isEnabled);
    localSetItem('SET_WELCOME_DIALOG', `${!isEnabled}`);
    if (!isEnabled) {
      dispatch(
        logging({
          category: 'C',
          action: 'Tankuang_Enabled',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            enabled: isEnabled,
          },
        }),
      );
    }
    Toast.success({ content: '设置成功' });
  };

  useEffect(() => {
    setIsEnabled(localGetItem('SET_WELCOME_DIALOG') === 'true' ? true : false);
  }, []);

  return (
    <div className="line">
      <div className="title">软件推荐设置</div>
      <div className="content">
        <div className="checkbox checkbox_clear" onClick={handleChoose}>
          {isEnabled ? <div className="checked" /> : <div className="no_checked" />}
          <span>开启精选软件推荐</span>
        </div>
        <div className="desc desc_margin_top">建议您开启精选软件推荐，为您每日推荐优质软件。</div>
      </div>
    </div>
  );
});
